import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
})
let redirecting = false
api.interceptors.response.use(response => response, error => {
  const pathname = (error.config?.url || '').split('?')[0].replace(/\/$/, '')
  const isLoginRequest = /\/auth\/login$/.test(pathname)
  const isPublicPage = /^\/(?:register|login)\/?$/.test(window.location.pathname) ||
    /^\/(?:sign|verify)\//.test(window.location.pathname)
  // 403/429/5xx and network failures are not evidence that the session expired.
  if (error.response?.status === 401 && !isLoginRequest && !isPublicPage) {
    localStorage.removeItem('user')
    localStorage.removeItem('lastActivity')
    localStorage.removeItem('token')
    window.dispatchEvent(new Event('staff-session-ended'))
    if (!redirecting && window.location.pathname !== '/login') {
      redirecting = true
      window.location.assign('/login')
    }
  }
  return Promise.reject(error)
})
export default api
